@import '../../../shared-scss/_mixins.scss';

:host {
	@include standardCardMaxWidth();
	box-sizing: border-box;
	* {
		box-sizing: border-box;
	}
}

.w2d-media-card {
	&__body {
		display: flex;
		flex-direction: column;
		gap: var(--ace-primitive-spacing-xx-tight);
		height: 100%;

		@include mq($desktop) {
			gap: var(--ace-primitive-spacing-x-tight);
    }
  }
}
